import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faGlobe, faHotel } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

const hospedajes = [
  {
    nombre: "Park Hotel Oliva",
    link: "https://maps.app.goo.gl/2A9WbLeWivpQXdnM7",
    direccion: (
      <>
        Roque Sáenz Peña 998
        <br />
        3532-496672
        <br />
        <a
          href="https://www.instagram.com/parkhoteloliva/?igsh=MXNlOHc5eHVlY3U0dg"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Park Hotel Oliva
        </a>
        <br />
        <a
          href="https://parkhotel.com.ar/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faGlobe} style={{ marginRight: 4 }} />
          Park Hotel Oliva
        </a>
      </>
    ),
  },
  {
    nombre: "Urban Suites Oliva",
    link: "https://maps.app.goo.gl/QUfmm3Ze5xRqtgcXA",
    direccion: (
      <>
        Roque Sáenz Peña
        <br />
        3532-447082
        <br />
        <a
          href="https://www.instagram.com/urbansuitesoliva/?igsh=aDJhajVrNnRjbmJv"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Urban Suites Oliva
        </a>
        <br />
        <a
          href="https://linktr.ee/urbansuiteso?fbclid=PAY2xjawH3RFJleHRuA2FlbQIxMQABpuo0XVJcJT8uGymtgZYozHeAcqzRXfrdmxwHF5GaePv3Rq6PllwR197JxA_aem_TV7BoifVryxX5c4qtfrUfA"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faGlobe} style={{ marginRight: 4 }} />
          Urban Suites Oliva
        </a>
      </>
    ),
  },
];

const Hospedajes = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon
            icon={faHotel}
            style={{ color: "#c0392b", marginRight: 8 }}
          />
          Hospedajes
        </h5>
        <ul className="lista-referencias">
          {hospedajes.map((hosp, i) => (
            <li key={i}>
              <FontAwesomeIcon
                icon={faMapLocationDot}
                style={{ marginRight: 8 }}
              />
              <a href={hosp.link} target="_blank" rel="noopener noreferrer">
                {hosp.nombre}
              </a>
              <div className="ms-2 me-auto">{hosp.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default Hospedajes;
